import React from 'react'
import Select from "react-select";
import NoRecordFound from '../../../components/ui/noRecordFound/NoRecordFound';

const CostAllocation = ({ title = "Cost Allocation", rows = [], options }) => {
    return (
        <>
            <div className="table-title mt-4">
                <h3>{title}</h3>
            </div>
            <div className="cost-allocation-list member-list">
                <div className="content-section">
                    <div className="table-section">
                        <table>
                            <thead>
                                <tr>
                                    <th>Cert Number</th>
                                    <th>Item Code</th>
                                </tr>
                            </thead>

                            <tbody>
                                {rows.length > 0 ? rows.map((row) => {
                                    
                                    const itemCode = options?.find((item) => item.value === row?.value);
                                    return (
                                        <tr key={row.id}>
                                            <td>{row.label}</td>
                                            <td>
                                                <div className="form-group">
                                                    <Select
                                                        className="custom-checkbox-select"
                                                        value={itemCode}
                                                        options={options}
                                                        isDisabled={true}
                                                    />
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                }): (
                                    <tr>
                                        <td colSpan={2}>
                                            <NoRecordFound/>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CostAllocation